import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { BehaviorSubject, Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { OrganizationStub } from '../../../../../common/models/organization.model';
import { AuthService } from '../../../../../services/auth.service';

@Component({
    selector: 'app-owner-well-info',
    templateUrl: './owner-well-info.component.html',
    styleUrls: ['./owner-well-info.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class OwnerWellInfoComponent extends ApplicationSectionBaseComponent implements OnInit {
    @Input() form: FormGroup;
    @Input() organization: OrganizationStub;
    @Input() application: WorkflowData;
  
    get isInternal(): boolean {
        return this._auth.User.isInternal;
    }

    reviewStates: ApplicationState[] = [
        ApplicationState.VerifyCompletion,
        ApplicationState.InitialReview,
        ApplicationState.InitialApproval,
        ApplicationState.FinalApproval
    ];

    constructor(public _auth: AuthService) {
        super(_auth);

    }

    ngOnInit() {
        if (this.application != null) {

        if (this.isInternal && this.application.applicationState == ApplicationState.Corrections) {
            this.form.disable();
        }
        }
      

    }


    onWellNotDrilledChecked(evt: Event): void {
        this.form.get("wellNotDrilled").setValue(evt.target['checked']);
    }




}
